import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Digiteal\CheckCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/CheckCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/check'
*/
const CheckCompanyToPeppolController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckCompanyToPeppolController.url(args, options),
    method: 'get',
})

CheckCompanyToPeppolController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/peppol/check',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Digiteal\CheckCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/CheckCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/check'
*/
CheckCompanyToPeppolController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return CheckCompanyToPeppolController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Digiteal\CheckCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/CheckCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/check'
*/
CheckCompanyToPeppolController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckCompanyToPeppolController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Digiteal\CheckCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/CheckCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/check'
*/
CheckCompanyToPeppolController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CheckCompanyToPeppolController.url(args, options),
    method: 'head',
})

export default CheckCompanyToPeppolController